module.exports = {"TXTWCL_Resend_code":{"id":"TXTWCL_Resend_code","defaultMessage":"Code erneut senden","track":"Resend code"}}